import { mutatorAction } from "satcheljs";
import { getStore, getCopilotChatDrawerState, getInitialState } from "../store/store";
import isPopout from "owa-popout-v2/lib/utils/isPopout";

/**
 * Updates the appCanvasWidth for the given window.
 *
 * This function also creates the state for the window if it doesn't exist,
 * as setting the appCanvasWidth can be called before a drawer is open.
 */
export const setAppCanvasWidthMutator: (targetWindow: Window, width: number) => void = mutatorAction("setAppCanvasWidthMutator", (targetWindow: Window, width: number): void => {
    const state = getCopilotChatDrawerState(targetWindow);
    if (state) {
        state.appCanvasWidth = width;
    }
    else {
        // Initialize initial instance of this state for this target window
        // getInitialState() restores the user's saved width from localStorage if available,
        // otherwise defaults to DEFAULT_COPILOT_CHAT_DRAWER_WIDTH.
        // For popouts, localStorage is skipped so they always get the default width.
        const newState = getInitialState(isPopout(targetWindow));
        newState.appCanvasWidth = width;
        getStore().chatDrawerStateMap.set(targetWindow, newState);
    }
});
